function isPassportIssueDateValid(birthDate: Date | null | undefined): boolean {
  if (birthDate == null) {
    return false;
  }

  const nowDate = new Date(Date.now());
  const minDate = new Date(nowDate.setUTCFullYear(nowDate.getFullYear() - 75));
  const dateDifferenceSeconds = Math.floor((Date.now() - birthDate.getTime()) / 1000);

  if (dateDifferenceSeconds < 0 || birthDate.getTime() < minDate.getTime()) {
    return false;
  }

  return true;
}

export default isPassportIssueDateValid;
